<app-inner-box>
  <app-subpage-header title="Übersicht">
    <div
      class="d-flex button-container"
      [class.is-active]="isCustomizeModeEnable"
      >
      @if (isCustomizeModeEnable) {
        <button
          nz-button
          nzType="default"
          nz-dropdown
          [nzDropdownMenu]="widgetsDropdown"
          nzTrigger="click"
          nzPlacement="bottomRight"
          >
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
          <span class="white-space-nowrap">
            Add widget
          </span>
        </button>
      }

      <button
        nz-button
        nzType="primary"
        nzGhost
        (click)="toggleCustomizeMode()"
        >
        <i nz-icon nzType="setting" nzTheme="outline"></i>
        <span>
          @if (isCustomizeModeEnable) {
            Speichern
          }

          @if (!isCustomizeModeEnable) {
            Anpassen
          }
        </span>
      </button>
    </div>
  </app-subpage-header>

  <div>
    <div class="dashboard-wrapper">
      <div
        class="charts-container"
        [class.noVisible]="!someWidgetsVisible"
        #chartsContainer
        [dragula]="isCustomizeModeEnable ? 'dashboard' : null"
        [(dragulaModel)]="dashboardView"
        >
        @if (someWidgetsVisible) {
          @for (chartConfig of dashboard.dashboard; track chartConfig) {
            @if (chartConfig.isVisible !== false) {
              <app-chart-wrapper
                [chartConfig]="chartConfig"
                [isCustomizeModeEnable]="isCustomizeModeEnable"
                [id]="chartConfig.key"
                [showDeleteButton]="true"
                #chartWrapperComponent
                >
                @switch (chartConfig.key) {
                  @case (dashboardChartTypes.NSD) {
                    <app-next-seminar-dates-chart />
                  }
                  @case (dashboardChartTypes.AQS) {
                    <app-article-quick-search-chart />
                  }
                  @case (dashboardChartTypes.LPO) {
                    <app-last-production-orders-chart />
                  }
                  @case (dashboardChartTypes.TPP) {
                    <app-top-products-last-30-days-chart />
                  }
                  @case (dashboardChartTypes.TSL) {
                    <app-today-sales-by-location-chart />
                  }
                  @case (dashboardChartTypes.MSIVS) {
                    <app-main-store-inactive-variants-with-stock-chart />
                  }
                  @case (dashboardChartTypes.SCN) {
                    <app-scanner-chart />
                  }
                  @case (dashboardChartTypes.LRC) {
                    <app-last-reclamations-chart />
                  }
                  @case (dashboardChartTypes.RCF) {
                    <app-recipe-card-finder-chart />
                  }
                  @case (dashboardChartTypes.MNS) {
                    <app-my-next-setup-steps-chart />
                  }
                  @case (dashboardChartTypes.OSP) {
                    <app-open-setup-steps-chart />
                  }
                }
              </app-chart-wrapper>
            }
          }
        } @else {
          <div
            class="d-flex align-items-center"
            >
            <div>
              <h4>
                No Widget
              </h4>
              <p class="p2">
                Um eine Vorschau der Daten zu erhalten, klicken Sie auf "Anpassen" in der oberen rechten Ecke und "Widget hinzufügen".
              </p>
            </div>
          </div>
        }

      </div>

      <nz-dropdown-menu #widgetsDropdown="nzDropdownMenu">
        <div style="padding: 8px;" nz-menu>
          <p style="margin-bottom: 4px;">
            Drag & Drop widget you want to add to your dashboard.
          </p>
          <div
            class="overflow-hidden"
            id="widgetsModal"
            dragula="dashboard"
            [(dragulaModel)]="modalView"
            >
            @if (!everyWidgetVisible) {
              @for (chartConfig of dashboard.dashboard; track chartConfig) {
                @if (chartConfig.isVisible === false) {
                  <app-chart-wrapper
                    [chartConfig]="chartConfig"
                    [isCustomizeModeEnable]="isCustomizeModeEnable"
                    [id]="chartConfig.key"
                    #chartWrapperComponent
                    >
                    @switch (chartConfig.key) {
                      @case (dashboardChartTypes.NSD) {
                        <app-next-seminar-dates-chart />
                      }
                      @case (dashboardChartTypes.AQS) {
                        <app-article-quick-search-chart />
                      }
                      @case (dashboardChartTypes.LPO) {
                        <app-last-production-orders-chart />
                      }
                      @case (dashboardChartTypes.TPP) {
                        <app-top-products-last-30-days-chart />
                      }
                      @case (dashboardChartTypes.TSL) {
                        <app-today-sales-by-location-chart />
                      }
                      @case (dashboardChartTypes.MSIVS) {
                        <app-main-store-inactive-variants-with-stock-chart />
                      }
                      @case (dashboardChartTypes.SCN) {
                        <app-scanner-chart />
                      }
                      @case (dashboardChartTypes.LRC) {
                        <app-last-reclamations-chart />
                      }
                      @case (dashboardChartTypes.RCF) {
                        <app-recipe-card-finder-chart />
                      }
                      @case (dashboardChartTypes.MNS) {
                        <app-my-next-setup-steps-chart />
                      }
                      @case (dashboardChartTypes.OSP) {
                        <app-open-setup-steps-chart />
                      }
                    }
                  </app-chart-wrapper>
                }
              }
            } @else {
              <div class="d-flex align-items-center justify-content-center full-width full-height">
                All widget are in use.
              </div>
            }

          </div>
        </div>
      </nz-dropdown-menu>
    </div>
  </div>
</app-inner-box>
